import jwtDecode from 'jwt-decode';

const decodeToken = (token) => {
    let decodedToken = {};
    try {
        decodedToken = jwtDecode(token);
    } catch (error) {
        console.log("=========================== token decoding error ==========================", error);
        return {};
    }
    return decodedToken;
}

export const hasPolicies = (policies) => {
    const { user } = decodeToken(localStorage.getItem('token'));
    return Array.isArray(user?.policies) && policies.every(p => user.policies.includes(p));
};

export default decodeToken;